interface ProgressBarProps {
  value: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ value }) => (
  <div className="bg-gray h-1 w-full" data-testid="progress-container">
    <div
      className="from-solid-gradient-start to-solid-gradient-end h-1 bg-gradient-to-r"
      data-testid="progress-bar"
      style={{ width: `${Math.min(value, 100)}%` }}
    />
  </div>
);

export default ProgressBar;
